import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { localBudgetService } from '../../../services/LocalBudgetService';
import ReactPaginate from 'react-paginate';

class AdminLocalBudget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newLocalBudget: {
        title: '',
        document: '',
        date: ''
      },
      existingLocalBudgets: [],
      deleteLocalBudget: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    localBudgetService
      .getAll()
      .then(jsonResponse => {
        this.setLocalBudgetState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    localBudgetService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setLocalBudgetState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setLocalBudgetState = response => {
    this.setState({
      existingLocalBudgets: response?.local_budgets || [],
      pagination: response?.pagination || {}
    });
  };

  updateField = event => {
    const field = event.target.name;
    const newLocalBudget = this.state.newLocalBudget;
    newLocalBudget[field] = event.target.value;

    this.setState({
      newLocalBudget
    });
  };

  onDropDocument = documents => {
    let newLocalBudget = { ...this.state.newLocalBudget };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newLocalBudget.document = documents[0];

      self.setState({ newLocalBudget });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newLocalBudget = { ...this.state.newLocalBudget };
    newLocalBudget.document = null;

    this.setState({ newLocalBudget });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newLocalBudget = { ...this.state.newLocalBudget };
    newLocalBudget = {
      title: '',
      document: '',
      add_date: ''
    };

    this.setState({ newLocalBudget });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newLocalBudget.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/local_budgets/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/local_budgets/${this.state.newLocalBudget.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingLocalBudgets = this.state.existingLocalBudgets.slice();

        let index = existingLocalBudgets.findIndex(
          existingConvocationAgenda =>
            existingConvocationAgenda.id === jsonResponse.id
        );

        if (index !== -1) {
          existingLocalBudgets[index] = jsonResponse;
        } else {
          existingLocalBudgets.push(jsonResponse);
        }

        this.setState({ existingLocalBudgets });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Bugetul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Bugetul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append('local_budget[title]', this.state.newLocalBudget.title);

    formData.append('local_budget[add_date]', this.state.newLocalBudget.date);

    if (this.state.newLocalBudget.document) {
      let document = this.state.newLocalBudget.document;
      appendAttachment(formData, `local_budget[document]`, document);
    }

    return formData;
  }

  setConvocationAgendaForEdit = newLocalBudgetDoc => {
    let newLocalBudget = { ...this.state.newLocalBudget };
    newLocalBudget = Object.assign({}, newLocalBudgetDoc);
    this.setState({ newLocalBudget });

    if (newLocalBudget.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteLocalBudget = { ...this.state.deleteLocalBudget };
    deleteLocalBudget = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteLocalBudget });
  };

  closeDeleteDialog = () => {
    let deleteLocalBudget = { ...this.state.deleteLocalBudget };
    deleteLocalBudget = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteLocalBudget });
  };

  handleDelete = () => {
    localBudgetService
      .deleteLocalBudget(this.state.deleteLocalBudget.deleteId)
      .then(() => {
        let existingLocalBudgets = this.state.existingLocalBudgets.slice();
        existingLocalBudgets = existingLocalBudgets.filter(
          localBudget =>
            localBudget.id !== this.state.deleteLocalBudget.deleteId
        );
        this.setState({ existingLocalBudgets });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Bugetul a fost sters cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Financiar
          </h3>
          <h1 className="admin-switch-title default-title">Buget Local</h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un buget nou</h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu buget*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newLocalBudget.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Data buget*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newLocalBudget.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document buget:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newLocalBudget.document}
                    documentFilename={
                      this.state.newLocalBudget.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newLocalBudget.id
                        ? 'Editează Buget'
                        : 'Adaugă Buget'}
                    </button>
                  </div>
                  {Object.values(this.state.newLocalBudget) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingLocalBudgets.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Bugete existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingLocalBudgets.map(localBudget => (
                      <div
                        className="existing-items__content-card"
                        key={localBudget.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {localBudget.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.setConvocationAgendaForEdit(localBudget)
                            }
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.openDeleteDialog(localBudget.id)
                            }
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteLocalBudget.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest document?"
                    aditionalText="Dupa stergere, documentul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminLocalBudget;
